module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-page u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page--container-small c-marg--before-footer u-relative"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "u-pad-l-xs u-marg-b-lg u-line-height--md t-text--md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.video.title)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-intra-video__player o-box--16by9 u-fit-w u-relative u-vacuum u-marg-b-md"
  }, [_c('div', {
    staticClass: "u-fit u-absolute u-pos-tl"
  }, [_c('div', {
    staticClass: "js-jwplayer"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97658172"}!./src/scripts/components/page-intra-video/template.html
// module id = 940
// module chunks = 0